import { del, get, post, put } from './client'

export interface OptionItem {
  key: string
  value: string
}

/**
 * 获取全部系统设置
 * GET /api/option
 */
export async function getOptionsApi(): Promise<OptionItem[]> {
  return get<OptionItem[]>('/api/option/')
}

/**
 * 更新单项系统设置
 * PUT /api/option
 */
export async function updateOptionApi(key: string, value: string): Promise<void> {
  return put('/api/option/', { key, value })
}

export interface BatchUpdateResult {
  saved: Array<{ key: string; value: string }>
  failed: Array<{ key: string; error: string }>
}

/**
 * 确认支付合规声明（充值/兑换/订阅/邀请奖励的前置条件）
 * POST /api/option/payment_compliance
 */
export async function confirmPaymentComplianceApi(): Promise<void> {
  await post('/api/option/payment_compliance', { confirmed: true })
}

/**
 * 批量保存（前端便捷方法，顺序 PUT；失败时返回已成功 key）
 */
export async function batchUpdateOptionsApi(
  items: Array<{ key: string; value: string | number | boolean }>
): Promise<BatchUpdateResult> {
  const saved: BatchUpdateResult['saved'] = []
  const failed: BatchUpdateResult['failed'] = []
  for (const it of items) {
    try {
      const value = String(it.value)
      await updateOptionApi(it.key, value)
      saved.push({ key: it.key, value })
    } catch (err) {
      failed.push({
        key: it.key,
        error: err instanceof Error ? err.message : '保存失败',
      })
    }
  }
  return { saved, failed }
}

/**
 * 重置模型基础倍率到后端默认值
 * POST /api/option/rest_model_ratio
 */
export async function resetModelRatioApi(): Promise<void> {
  return post('/api/option/rest_model_ratio')
}

export {
  getRatioSyncChannelsApi,
  fetchRatioSyncDiffApi,
  type RatioSyncChannel,
  type RatioSyncFetchResult,
  type RatioSyncDifferenceItem,
} from './ratioSync'

/** GET /api/option/channel_affinity_cache */
export async function getChannelAffinityCacheStatsApi(): Promise<unknown> {
  return get('/api/option/channel_affinity_cache')
}

/** DELETE /api/option/channel_affinity_cache?all=true */
export async function clearChannelAffinityCacheApi(all = false): Promise<void> {
  return del('/api/option/channel_affinity_cache', { params: all ? { all: 'true' } : undefined })
}
